import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";

const initialState = {} as IAddPatientResponse;

const addedPatientSlice = createSlice({
    name: "addedPatientInfo",
    initialState,
    reducers: {
        setAddedPatientInfo: (state, action: PayloadAction<IAddPatientResponse>) => {
            Object.assign(state, action.payload);
        },
    },
});

export const { setAddedPatientInfo } = addedPatientSlice.actions;
export default addedPatientSlice.reducer;

export const getAddedPatientInfo = (state: RootState) => state.addedPatientInfo;
